// @flow

import React from 'react';
import { I18n } from 'react-redux-i18n';
import type { ShoppingCenter } from '../../../../types/shoppingCenterType';
import IconButton from '../../../../components/IconButton';
import { download } from '../../../../utils/utils';
import storesApi from '../../../../network/api/storesApi';
import { notifyApolloError } from '../../../../network/notification';

type State = {
  isGoodwillLoading: boolean,
}

type Props = {
  dispatch: () => void,
  shoppingCenter: ShoppingCenter,
  selectedCodstr: number,
  selectedStoreName: string,
  buttonName: React.Fragment,
}

class GoodwillButton extends React.PureComponent<Props> {
  state: State = {
    isGoodwillLoading: false,
  }

  render() {
    return (
      <div className="btn-apollo-container">
        <IconButton
          icon="fal fa-file-download"
          className={`ripple-button ${this.state.isGoodwillLoading ? 'disabled' : ''} apollo-button-contained`}
          isLoading={this.state.isGoodwillLoading}
          onClick={() => {
            this.setState({ isGoodwillLoading: true });
            storesApi.generateGoodwill(
              this.props.shoppingCenter.id,
              this.props.selectedCodstr,
            )
              .then(excel => excel.blob())
              .then((responseBlob) => {
                download(
                  responseBlob,
                  I18n.t(
                    'SIDE_MENU.goodwill_report_filename',
                    {
                      retailerName: this.props.selectedStoreName,
                      shoppingCenter: this.props.shoppingCenter.name,
                    },
                  ),
                );
              })
              .catch(e => this.props.dispatch(notifyApolloError(e)))
              .finally(() => this.setState({ isGoodwillLoading: false}));
            }
          }
        >
          {this.props.buttonName}
        </IconButton>
      </div>
    );
  }
}

export default GoodwillButton;
